// src/context/UserContext.js
import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../config/config";

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const registerUser = async (formData) => {
    try {
      const response = await axios.post(`${BASE_URL}/users`, {
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        password: formData.password,
      });

      if (response.status === 201) {
        setUser(response.data.data); // store user if needed
        return {
          success: true,
          message: response.data.message,
          user: response.data.data,
        };
      }

      return { success: false, message: "Unexpected response from server." };

    } catch (error) {
      console.error("Registration failed:", error);
      return {
        success: false,
        message:
          error.response?.data?.message || "Failed to register user. Please try again.",
      };
    }
  };

  return (
    <UserContext.Provider value={{ user, registerUser }}>
      {children}
    </UserContext.Provider>
  );
};
